import Util from '@/helper/Utility.js';

export function QuotaConfigModel (catId, group, tier, level) {
    this.catId = catId || null;
    this.group = group || null;
    this.tier = tier || null;
    this.level = level || null;

    this.getParams = function () {
        var params = {
            privilegeId: this.catId,
            group: this.group,
            tier: this.tier,
            level: this.level
        };

        params = Util.cleanObjectNullKey(params);
        return params;
    }
}

export function QuotaConfigBuilder () {
    this.quotaConfig = new QuotaConfigModel();

    this.create = () => {
        return this.quotaConfig;
    };

    this.setCatId =(catId) => {
        this.quotaConfig.catId = catId;
        return this;
    };

    this.setGroup = (group) => {
        this.quotaConfig.group = group;
        return this;
    };

    this.setTier = (tier) => {
        this.quotaConfig.tier = tier;
        return this;
    };

    this.setLevel = (level) => {
        this.quotaConfig.level = level;
        return this;
    };
}
